import { UserDetailsResponseDtoAppFeaturesItem } from '@/generated/nabisNYWebAPI.schemas';
import { OrganizationFeatureMap } from '../types/user-types';

export const getHasAllFeaturesForOrganization =
  (organizationFeatures: OrganizationFeatureMap, organizationId: string | undefined) =>
  (features: UserDetailsResponseDtoAppFeaturesItem[], orgId = organizationId) => {
    if (!orgId) {
      return false;
    }

    const organizationFeatureArray = organizationFeatures.get(orgId) ?? [];
    return features.every((f) => organizationFeatureArray.includes(f));
  };
